import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AccountSelectors, CurrentUserSelectors } from '@core/account-data';
import { filterBoolean } from '@core/common-legacy';
import type { FeatureDiscoveryFeatures } from '@core/feature-discovery-types';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  private readonly store = inject(Store);

  public currentUser$ = this.store.select(CurrentUserSelectors.data).pipe(filterBoolean);
  public currentCompany$ = this.store.select(AccountSelectors.currentCompany).pipe(filterBoolean);
  public currentCompanyWithUser$ = this.store
    .select(AccountSelectors.currentCompanyWithUser)
    .pipe(filterBoolean);

  public featureDiscovered(feature: keyof FeatureDiscoveryFeatures) {
    return this.currentUser$.pipe(map(currentUser => currentUser.featureDiscovery[feature]));
  }
}
